/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VoipUserModel } from '../../models/voip-user-model';

export interface VoipGetUserGet$Params {
}

export function voipGetUserGet(http: HttpClient, rootUrl: string, params?: VoipGetUserGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<VoipUserModel>> {
  const rb = new RequestBuilder(rootUrl, voipGetUserGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<VoipUserModel>;
    })
  );
}

voipGetUserGet.PATH = '/Voip/GetUser';
